import useTranslation from '../useTranslation';
import { useState } from 'react';
import { formatToUSDate } from 'utils/dateTimeUtils/dateFormatUtil';
import downloadBlob from 'utils/downloadBlob';
import formatPdfFilename from 'utils/formatPdfFilename';
import generateFlightsPdf from 'utils/generateFlightsPdf';
import { MAX_FLIGHTS_PER_EXPORT } from 'utils/generateFlightsPdf/constants';

import { ERROR_TYPE } from 'components/ExportDropdown/constants';

import useToast from 'hooks/useToast';

import type { UseExportPdfProps, UseExportPdfReturn } from './types';

const useExportPdf = ({ selectedFlights }: UseExportPdfProps): UseExportPdfReturn => {
    const [isExporting, setIsExporting] = useState(false);
    const { broadcastToast } = useToast();
    const { EXPORT_PDF_FAILED, SPRAY, SPREAD, TOO_MANY_FLIGHTS, UNKNOWN } = useTranslation();

    const applicationTypeLabels: Record<string, string> = {
        SPRAY: SPRAY,
        SPREAD: SPREAD,
        UNRECOGNIZED: UNKNOWN
    };

    const handleExportPdf = async () => {
        if (selectedFlights.length > MAX_FLIGHTS_PER_EXPORT) {
            await broadcastToast({ text: TOO_MANY_FLIGHTS, type: ERROR_TYPE });

            return;
        }

        try {
            setIsExporting(true);

            const blob = generateFlightsPdf({
                applicationTypeLabels,
                flights: selectedFlights,
                generatedDate: formatToUSDate(new Date()),
                totalFlightCount: selectedFlights.length
            });

            downloadBlob({ blob, filename: formatPdfFilename() });
        } catch {
            await broadcastToast({ text: EXPORT_PDF_FAILED, type: ERROR_TYPE });
        } finally {
            setIsExporting(false);
        }
    };

    return {
        handleExportPdf,
        isExporting
    };
};

export default useExportPdf;
